import { cn } from '@/utils/tailwind';
import { getColor, getPercent } from '../_utils';

interface SalesItem {
  SalesAmount: number;
  MarketName: string;
}

interface ColorDistributionBarProps<T extends SalesItem> {
  salesItemList: Array<T>;
  activedMonthlySalesAmount: number;
  PcVersion?: boolean;
}

const ColorDistributionBar = <T extends SalesItem>({
  salesItemList,
  activedMonthlySalesAmount,
  PcVersion = false,
}: ColorDistributionBarProps<T>) => {
  const salesWithPercent = salesItemList.map((item) => ({
    ...item,
    percentValue: getPercent(item.SalesAmount, activedMonthlySalesAmount),
  }));

  return (
    <div
      className={cn(
        'mb-[24px] mt-[36px] flex h-[40px] w-full items-center overflow-hidden rounded-[10px] border-[1px] border-gr-200',
        PcVersion && 'mb-0 mt-0',
      )}
    >
      {salesWithPercent.map((item, index) => (
        <div
          key={`${item.MarketName} ${item.SalesAmount} ${index}`}
          className={cn('h-full', getColor(index).graph)}
          style={{
            width: `${item.percentValue}%`,
            transition: 'none',
          }}
        ></div>
      ))}
    </div>
  );
};

export default ColorDistributionBar;
